import { getOr } from 'lodash/fp';
import { checkRequiredField } from '../lib';
import createSimpleValidator from '../lib/createSimpleValidator';

// URL avec protocole http/https obligatoire
const checkIsUrl = createSimpleValidator(
    (value) => /^https?:\/\/[^\s/$.?#][^\s]*$/i.test(value),
    'Vous devez entrer une URL valide (http:// ou https://).',
);

// identifiant client OpenWealth : lettres, chiffres, "-" et "_" uniquement
const checkIsClientId = createSimpleValidator(
    (value) => /^[A-Za-z0-9_-]+$/.test(value),
    'Vous devez entrer un identifiant client valide (lettres, chiffres, "-" et "_" uniquement).',
);

// secret client OpenWealth : ni vide, ni espaces (le champ est masqué comme un mot de passe)
const checkIsClientSecret = createSimpleValidator(
    (value) => /^\S+$/.test(value),
    'Vous devez entrer un secret client valide (sans espace).',
);

export const buildBusinessPartnerValidation = (prefix = '') => [
    checkRequiredField(`${prefix}name`),
    checkRequiredField(`${prefix}grantType`),
    checkRequiredField(`${prefix}clientId`),
    checkIsClientId(`${prefix}clientId`),
    checkRequiredField(`${prefix}urlSouscription`),
    checkIsUrl(`${prefix}urlSouscription`),
    checkRequiredField(`${prefix}clientSecret`),
    checkIsClientSecret(`${prefix}clientSecret`),
    checkRequiredField(`${prefix}urlToken`),
    checkIsUrl(`${prefix}urlToken`),
    checkRequiredField(`${prefix}hasManagementAct`),
];

export const businessPartnerValidators = (businessPartner) => buildBusinessPartnerValidation(`businessPartner.${businessPartner}.`);

const validators = (businessPartners) => Object
    .keys(getOr({}, 'businessPartner', businessPartners))
    .reduce((acc, businessPartner) => [...acc, ...businessPartnerValidators(businessPartner)], []);

export default validators;
